import React, { useState, useEffect } from "react";
import EmailIcon from "@rsuite/icons/Email";
import PhoneIcon from "@rsuite/icons/Phone";
import AuthUser from "../../services/AuthUser";
import defaultUserAvatar from "../../assets/user-avatar.jpg";
import "./inquiry.styles.scss";
import {
  Uploader,
  Message,
  Loader,
  useToaster,
  Table,
  Popover,
  Whisper,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { API_URL } from "../../shared/constant";
import { format } from "date-fns";
import { Link } from "react-router-dom";
const { Column, HeaderCell, Cell } = Table;
function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

const Inquiry = () => {
  const { user, token, http } = AuthUser();
  const toaster = useToaster();
  const [uploading, setUploading] = useState(false);
  const [fileInfo, setFileInfo] = useState(null);
  const [inquiryData, setInquiryData] = useState([]);
  useEffect(() => {
    http
      .get(API_URL.INQUIRY)
      .then((response) => {
        if (response.status === 200) {
          setInquiryData(response.data.data);
        }
      })
      .catch((err) => {
        console.log("Error from inquiry list");
      });
  }, [http]);

  const DateCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: "46px" }}>
        {format(new Date(rowData.created_at), "dd MMM, Y")}
      </div>
    </Cell>
  );

  const CliffCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: "46px" }}>
        <Whisper
          placement="top"
          trigger="hover"
          controlId="control-id-hover"
          speaker={
            <Popover title="NYSA CENTRAL TEXAS LP">
              <p className="mb-1">
                <EmailIcon className="mr-1" />
                <Link
                  className="text-thm mr-1"
                  to={`mailto:${rowData.cliff.email}`}
                >
                  {rowData.cliff.email}
                </Link>
              </p>
              <p className="mb-1">
                <PhoneIcon className="mr-1" />
                <Link
                  className="text-thm"
                  to={`tel:${rowData.cliff.phone_number}`}
                >
                  {rowData.cliff.phone_number}
                </Link>
              </p>
            </Popover>
          }
        >
          <Link className="text-thm">NYSA CENTRAL TEXAS LP</Link>
        </Whisper>
      </div>
    </Cell>
  );

  return (
    <section className="header-padding">
      <div className="container rounded bg-white">
        <div className="row">
          <div className="col-md-3 border-right">
            <div className="d-flex flex-column align-items-center text-center p-3 py-5">
              <Uploader
                multiple={false}
                name="photo"
                disabled
                fileListVisible={false}
                listType="picture"
                action={API_URL.PROFILE_PICTURE}
                accept="image/*"
                headers={{
                  "Content-type": "application/json",
                  "Bearer-Token": token,
                }}
                onUpload={(file) => {
                  setUploading(true);
                  previewFile(file.blobFile, (value) => {
                    setFileInfo(value);
                  });
                }}
                onSuccess={(response, file) => {
                  setUploading(false);
                  toaster.push(
                    <Message type="success">Uploaded successfully</Message>
                  );
                }}
                onError={() => {
                  setFileInfo(null);
                  setUploading(false);
                  toaster.push(<Message type="error">Upload failed</Message>);
                }}
              >
                <button style={{ width: 150, height: 150 }}>
                  {uploading && <Loader backdrop center />}
                  {fileInfo ? (
                    <img
                      src={fileInfo}
                      width="100%"
                      height="100%"
                      alt={user.name}
                    />
                  ) : (
                    <img
                      src={user.photo ? user.photo : defaultUserAvatar}
                      width="100%"
                      height="100%"
                      alt={user.name}
                    />
                  )}
                </button>
              </Uploader>
              <br />
              <span className="font-weight-bold">{user.name}</span>
              <span className="text-black-50">{user.email}</span>
              <span className="text-black-50">{user.phone}</span>
            </div>
          </div>
          <div className="col-md-9">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-right">My Inquiry</h4>
              </div>
              <Table virtualized height={400} data={inquiryData}>
                <Column width={70} align="center" fixed>
                  <HeaderCell>#Inq-no.</HeaderCell>
                  <Cell dataKey="id" />
                </Column>
                <Column width={70}>
                  <HeaderCell>Plot No.</HeaderCell>
                  <Cell dataKey="plot_no" />
                </Column>
                <Column width={250}>
                  <HeaderCell>Property Name</HeaderCell>
                  <Cell dataKey="property_name" />
                </Column>
                <Column width={200}>
                  <HeaderCell>Cliff Details</HeaderCell>
                  <CliffCell dataKey="cliff" />
                </Column>
                <Column width={250}>
                  <HeaderCell>Your inq. Discriptipn</HeaderCell>
                  <Cell dataKey="details" />
                </Column>

                <Column width={120}>
                  <HeaderCell>Date</HeaderCell>
                  <DateCell dataKey="created_at" />
                </Column>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inquiry;
